import React from "react";
import { Link } from "react-router-dom";

/**
 * Forrás-Kód® Kísérés — főoldali kiemelt ajánló blokk.
 * Közvetlenül a navigáció alatt jelenik meg, az első hajtás felett.
 * A meglévő arculatot használja: Cormorant + Inter, bg-warm / bg-tinted,
 * hairline, finom arany kiemelések, portrait-frame keret.
 *
 * Kép helyörző: egy esztétikus "— Kép hamarosan" blokk a saját fotó
 * érkezéséig. A képarány 4:5 (portré-barát), de bármilyen formátumra
 * illeszkedik majd.
 */
export default function ForrasKodHighlight() {
  return (
    <section
      id="forras-kod-highlight"
      data-testid="forras-kod-highlight"
      aria-labelledby="forras-kod-highlight-title"
      className="relative pt-24 md:pt-28 px-5 md:px-10"
    >
      <div className="max-w-6xl mx-auto border border-hairline bg-tinted">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-0 items-stretch">
          {/* Image side */}
          <div className="md:col-span-5 relative border-b md:border-b-0 md:border-r border-hairline overflow-hidden">
            <img
              src="/images/forras-kod-highlight.jpg"
              alt="Forrás-Kód® Kísérés — csoportos beszélgetés, őszinte kapcsolódás"
              data-testid="forras-kod-highlight-image"
              className="w-full h-full object-cover block"
              style={{
                minHeight: "280px",
                aspectRatio: "auto",
                filter: "saturate(0.98) contrast(1.02)",
              }}
              loading="eager"
            />
          </div>

          {/* Text side */}
          <div className="md:col-span-7 px-7 md:px-12 lg:px-16 py-12 md:py-16 flex flex-col items-center md:items-start justify-center text-center md:text-left">
            {/* Hairline + eyebrow */}
            <div className="flex items-center gap-4 mb-6">
              <span className="hidden md:block w-10 h-px bg-gold opacity-70" />
              <p
                data-testid="forras-kod-highlight-eyebrow"
                className="font-body text-[11px] md:text-[12px] tracking-[0.42em] uppercase text-gold"
              >
                Új szolgáltatás
              </p>
            </div>

            <h2
              id="forras-kod-highlight-title"
              data-testid="forras-kod-highlight-title"
              className="font-serif-display text-[34px] sm:text-[42px] md:text-[48px] lg:text-[56px] leading-[1.08] text-graphite tracking-tight mb-8 md:mb-10"
            >
              Forrás-Kód
              <sup className="text-gold text-[0.4em] align-super ml-0.5 relative -top-2 md:-top-3">
                ®
              </sup>{" "}
              <em className="text-gold" style={{ fontStyle: "italic" }}>
                Kísérés
              </em>
            </h2>

            <Link
              to="/forras-kod-kiseres"
              data-testid="forras-kod-highlight-cta"
              className="cta-gold-outline inline-flex items-center gap-3 px-8 py-3.5 text-[11.5px] md:text-[12px] uppercase font-body font-medium tracking-[0.22em]"
            >
              Ismerd meg a folyamatot
              <span aria-hidden="true">→</span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
